import { render } from "./Index.vue?vue&type=template&id=2af070c6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2af070c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2af070c6"

export default script